import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
function f(e) {
	return e instanceof Date ? e.toISOString() : String(e);
}
var p = class extends t {
	instance;
	baseUrl;
	jsonParseReviver;
	constructor(e, t) {
		super(), this.instance = t ?? n.create(), this.baseUrl = e ?? "http://127.0.0.1:7071/agencies";
	}
	assignStaffMemberToAgencies(e, t) {
		let r = this.baseUrl + "/AssignStaffMemberToAgencies", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processAssignStaffMemberToAgencies(e)));
	}
	processAssignStaffMemberToAgencies(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	createAgency(e, t) {
		let r = this.baseUrl + "/CreateAgency", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processCreateAgency(e)));
	}
	processCreateAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	createAgent(e, t) {
		let r = this.baseUrl + "/CreateAgent", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processCreateAgent(e)));
	}
	processCreateAgent(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	deleteAgencySupplier(e, t) {
		let r = this.baseUrl + "/DeleteAgencySupplier", i = {
			method: "PUT",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processDeleteAgencySupplier(e)));
	}
	processDeleteAgencySupplier(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	generateEventSubscriptions(e) {
		let t = this.baseUrl + "/GenerateEventSubscriptions", r = {
			method: "POST",
			url: t,
			headers: {},
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGenerateEventSubscriptions(e)));
	}
	processGenerateEventSubscriptions(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 204 || e.status === 200 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAgenciesAssignedToStaffMember(e, t) {
		let r = this.baseUrl + "/GetAgenciesAssignedToStaffMember", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetAgenciesAssignedToStaffMember(e)));
	}
	processGetAgenciesAssignedToStaffMember(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAgencyDetails(e, t) {
		let r = this.baseUrl + "/GetAgencyDetails";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetAgencyDetails(e)));
	}
	processGetAgencyDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAgencyInformationForUser(e) {
		let t = this.baseUrl + "/GetAgencyInformationForUser", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetAgencyInformationForUser(e)));
	}
	processGetAgencyInformationForUser(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAgencyMembers(e, t) {
		let r = this.baseUrl + "/GetAgencyMembers";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetAgencyMembers(e)));
	}
	processGetAgencyMembers(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAgencySuppliers(e, t) {
		let r = this.baseUrl + "/GetAgencySuppliers";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetAgencySuppliers(e)));
	}
	processGetAgencySuppliers(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAgentProfile(e) {
		let t = this.baseUrl + "/GetAgentProfile", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetAgentProfile(e)));
	}
	processGetAgentProfile(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAgentsInAgency(e) {
		let t = this.baseUrl + "/GetAgentsInAgency", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetAgentsInAgency(e)));
	}
	processGetAgentsInAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAllAgencies(e) {
		let t = this.baseUrl + "/GetAllAgencies", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetAllAgencies(e)));
	}
	processGetAllAgencies(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAllUsersInformation(e) {
		let t = this.baseUrl + "/GetAllUsersInformation", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetAllUsersInformation(e)));
	}
	processGetAllUsersInformation(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAutopilotEntityDetails(e) {
		let t = this.baseUrl + "/GetAutopilotEntityDetails", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetAutopilotEntityDetails(e)));
	}
	processGetAutopilotEntityDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getBranding(e, t) {
		let r = this.baseUrl + "/GetBranding";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetBranding(e)));
	}
	processGetBranding(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCommissionSettings(e, t) {
		let r = this.baseUrl + "/GetCommissionSettings";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCommissionSettings(e)));
	}
	processGetCommissionSettings(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getContractSettings(e, t) {
		let r = this.baseUrl + "/GetContractSettings";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetContractSettings(e)));
	}
	processGetContractSettings(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getEntityGoals(e) {
		let t = this.baseUrl + "/GetEntityGoals", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetEntityGoals(e)));
	}
	processGetEntityGoals(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getExecutiveKeyBudget(e) {
		let t = this.baseUrl + "/GetExecutiveKeyBudget", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetExecutiveKeyBudget(e)));
	}
	processGetExecutiveKeyBudget(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getFeatureToggles(e) {
		let t = this.baseUrl + "/GetFeatureToggles", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetFeatureToggles(e)));
	}
	processGetFeatureToggles(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getLabGroupAgencyCode(e, t) {
		let r = this.baseUrl + "/GetLabGroupAgencyCode";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetLabGroupAgencyCode(e)));
	}
	processGetLabGroupAgencyCode(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getListingAgreementSettings(e, t) {
		let r = this.baseUrl + "/GetListingAgreementSettings";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetListingAgreementSettings(e)));
	}
	processGetListingAgreementSettings(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getPublicHolidays(e, t) {
		let r = this.baseUrl + "/GetPublicHolidays";
		if (r += "?", e === null) throw new globalThis.Error("The parameter 'state' cannot be null.");
		e !== void 0 && (r += "state=" + encodeURIComponent(f(e)) + "&"), r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetPublicHolidays(e)));
	}
	processGetPublicHolidays(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getStaffMembersAssignedToAgencies(e, t, r) {
		let i = this.baseUrl + "/GetStaffMembersAssignedToAgencies";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'role' must be defined and cannot be null.");
		if (i += "role=" + encodeURIComponent(f(e)) + "&", t === null) throw new globalThis.Error("The parameter 'agencyIds' cannot be null.");
		if (t !== void 0) for (let e of t) i += "agencyIds=" + encodeURIComponent(f(e)) + "&";
		i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processGetStaffMembersAssignedToAgencies(e)));
	}
	processGetStaffMembersAssignedToAgencies(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getTeamsForAgency(e, t) {
		let r = this.baseUrl + "/GetTeamsForAgency";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetTeamsForAgency(e)));
	}
	processGetTeamsForAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getUploadedFileLink(e, t) {
		let r = this.baseUrl + "/GetUploadedFileLink";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'filePath' must be defined and cannot be null.");
		r += "filePath=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetUploadedFileLink(e)));
	}
	processGetUploadedFileLink(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getUrbanXTeamForAgency(e, t) {
		let r = this.baseUrl + "/GetUrbanXTeamForAgency";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetUrbanXTeamForAgency(e)));
	}
	processGetUrbanXTeamForAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	removeFile(e, t) {
		let r = this.baseUrl + "/RemoveFile", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processRemoveFile(e)));
	}
	processRemoveFile(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	removePublicDocument(e, t) {
		let r = this.baseUrl + "/RemovePublicDocument", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processRemovePublicDocument(e)));
	}
	processRemovePublicDocument(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	sendInvitationEmail(e, t) {
		let r = this.baseUrl + "/SendInvitationEmail", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSendInvitationEmail(e)));
	}
	processSendInvitationEmail(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 204 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 200 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	setAgentDetails(e, t) {
		let r = this.baseUrl + "/SetAgentDetails", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSetAgentDetails(e)));
	}
	processSetAgentDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	setEntityGoals(e, t) {
		let r = this.baseUrl + "/SetEntityGoals", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSetEntityGoals(e)));
	}
	processSetEntityGoals(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	setExecutiveKeyBudget(e, t) {
		let r = this.baseUrl + "/SetExecutiveKeyBudget", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSetExecutiveKeyBudget(e)));
	}
	processSetExecutiveKeyBudget(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	setTeamsForAgency(e, t) {
		let r = this.baseUrl + "/SetTeamsForAgency", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSetTeamsForAgency(e)));
	}
	processSetTeamsForAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	setUrbanXTeamForAgency(e, t) {
		let r = this.baseUrl + "/SetUrbanXTeamForAgency", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSetUrbanXTeamForAgency(e)));
	}
	processSetUrbanXTeamForAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	softDeleteAgent(e, t) {
		let r = this.baseUrl + "/SoftDeleteAgent", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSoftDeleteAgent(e)));
	}
	processSoftDeleteAgent(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 204 ? Promise.resolve(null) : e.status === 400 || e.status === 401 || e.status === 404 ? B("No description", e.status, e.data, t) : e.status === 200 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetAgentsInAgency(e, t) {
		let r = this.baseUrl + "/StaffGetAgentsInAgency";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetAgentsInAgency(e)));
	}
	processStaffGetAgentsInAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetAllAgents(e) {
		let t = this.baseUrl + "/StaffGetAllAgents", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processStaffGetAllAgents(e)));
	}
	processStaffGetAllAgents(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetAnnualBusinessTargets(e, t) {
		let r = this.baseUrl + "/StaffGetAnnualBusinessTargets";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetAnnualBusinessTargets(e)));
	}
	processStaffGetAnnualBusinessTargets(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 404 ? B("Payload of String", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetFeatureToggleManagement(e) {
		let t = this.baseUrl + "/StaffGetFeatureToggleManagement", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processStaffGetFeatureToggleManagement(e)));
	}
	processStaffGetFeatureToggleManagement(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetFeatureToggles(e, t) {
		let r = this.baseUrl + "/StaffGetFeatureToggles";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetFeatureToggles(e)));
	}
	processStaffGetFeatureToggles(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetPartnershipDetailsForAgency(e, t) {
		let r = this.baseUrl + "/StaffGetPartnershipDetailsForAgency";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetPartnershipDetailsForAgency(e)));
	}
	processStaffGetPartnershipDetailsForAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffSetAnnualBusinessTargets(e, t) {
		let r = this.baseUrl + "/StaffSetAnnualBusinessTargets", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffSetAnnualBusinessTargets(e)));
	}
	processStaffSetAnnualBusinessTargets(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 404 ? B("Payload of String", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffSetPartnershipDetailsForAgency(e, t) {
		let r = this.baseUrl + "/StaffSetPartnershipDetailsForAgency", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffSetPartnershipDetailsForAgency(e)));
	}
	processStaffSetPartnershipDetailsForAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 || e.status === 404 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateFeatureSetting(e, t) {
		let r = this.baseUrl + "/StaffUpdateFeatureSetting", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateFeatureSetting(e)));
	}
	processStaffUpdateFeatureSetting(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 || e.status === 409 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateAgency(e, t) {
		let r = this.baseUrl + "/UpdateAgency", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateAgency(e)));
	}
	processUpdateAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 || e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateAgencySuppliers(e, t) {
		let r = this.baseUrl + "/UpdateAgencySuppliers", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateAgencySuppliers(e)));
	}
	processUpdateAgencySuppliers(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateAgentProfile(e, t) {
		let r = this.baseUrl + "/UpdateAgentProfile", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateAgentProfile(e)));
	}
	processUpdateAgentProfile(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateAutopilotEntityDetails(e, t) {
		let r = this.baseUrl + "/UpdateAutopilotEntityDetails", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateAutopilotEntityDetails(e)));
	}
	processUpdateAutopilotEntityDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateBranding(e, t, r) {
		let i = this.baseUrl + "/UpdateBranding";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		i = i.replace(/* @__PURE__ */ RegExp("\\{agencyId(?::[^}]+)?\\}", "gi"), encodeURIComponent(f(e)));
		let a = JSON.stringify(t), o = {
			method: "PUT",
			url: i,
			headers: { "Content-Type": "application/json" },
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processUpdateBranding(e)));
	}
	processUpdateBranding(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateCommissionSettings(e, t, r) {
		let i = this.baseUrl + "/UpdateCommissionSettings";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		i = i.replace(/* @__PURE__ */ RegExp("\\{agencyId(?::[^}]+)?\\}", "gi"), encodeURIComponent(f(e)));
		let a = JSON.stringify(t), o = {
			method: "PUT",
			url: i,
			headers: { "Content-Type": "application/json" },
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processUpdateCommissionSettings(e)));
	}
	processUpdateCommissionSettings(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateContractSettings(e, t, r) {
		let i = this.baseUrl + "/UpdateContractSettings";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		i = i.replace(/* @__PURE__ */ RegExp("\\{agencyId(?::[^}]+)?\\}", "gi"), encodeURIComponent(f(e)));
		let a = JSON.stringify(t), o = {
			method: "PUT",
			url: i,
			headers: { "Content-Type": "application/json" },
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processUpdateContractSettings(e)));
	}
	processUpdateContractSettings(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateLabGroupAgencyCode(e, t) {
		let r = this.baseUrl + "/UpdateLabGroupAgencyCode", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateLabGroupAgencyCode(e)));
	}
	processUpdateLabGroupAgencyCode(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 || e.status === 204 ? Promise.resolve(null) : e.status === 400 || e.status === 401 || e.status === 404 ? B("No description", e.status, e.data, t) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateListingAgreementSettings(e, t, r) {
		let i = this.baseUrl + "/UpdateListingAgreementSettings";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		i = i.replace(/* @__PURE__ */ RegExp("\\{agencyId(?::[^}]+)?\\}", "gi"), encodeURIComponent(f(e)));
		let a = JSON.stringify(t), o = {
			method: "PUT",
			url: i,
			headers: { "Content-Type": "application/json" },
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processUpdateListingAgreementSettings(e)));
	}
	processUpdateListingAgreementSettings(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	uploadAgentProfilePhoto(e, t) {
		let r = this.baseUrl + "/UploadAgentProfilePhoto", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUploadAgentProfilePhoto(e)));
	}
	processUploadAgentProfilePhoto(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	uploadDocument(e, t) {
		let r = this.baseUrl + "/UploadDocument", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUploadDocument(e)));
	}
	processUploadDocument(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	uploadPublicDocument(e, t) {
		let r = this.baseUrl + "/UploadPublicDocument";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "POST",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUploadPublicDocument(e)));
	}
	processUploadPublicDocument(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
}, m = /* @__PURE__ */ function(e) {
	return e.UrbanX = "UrbanX", e.Autopilot = "Autopilot", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.None = "None", e.RealEstateCertificate = "RealEstateCertificate", e.RealEstateLicence = "RealEstateLicence", e.Class1 = "Class1", e.Class2 = "Class2", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.UrbanX = "UrbanX", e.Autopilot = "Autopilot", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.UrbanX = "UrbanX", e.Autopilot = "Autopilot", e;
}({}), v = /* @__PURE__ */ function(e) {
	return e.None = "None", e.RealEstateCertificate = "RealEstateCertificate", e.RealEstateLicence = "RealEstateLicence", e.Class1 = "Class1", e.Class2 = "Class2", e;
}({}), y = /* @__PURE__ */ function(e) {
	return e.QLDResidentialForm6 = "QLDResidentialForm6", e.NSWResidentialAgreement = "NSWResidentialAgreement", e.NSWRuralAgreement = "NSWRuralAgreement", e;
}({}), b = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), x = /* @__PURE__ */ function(e) {
	return e.ConfirmWithAgent = "ConfirmWithAgent", e.Original = "Original", e.Reduced = "Reduced", e;
}({}), S = /* @__PURE__ */ function(e) {
	return e.UnderOffer = "UnderOffer", e.Sold = "Sold", e.DoNotUpdate = "DoNotUpdate", e;
}({}), C = /* @__PURE__ */ function(e) {
	return e.Available = "Available", e.UnderOffer = "UnderOffer", e;
}({}), ee = /* @__PURE__ */ function(e) {
	return e.Connected = "Connected", e.PendingValidation = "PendingValidation", e;
}({}), te = /* @__PURE__ */ function(e) {
	return e.Rex = "Rex", e.Agentbox = "Agentbox", e.BoxAndDice = "BoxAndDice", e.Vault = "Vault", e;
}({}), w = /* @__PURE__ */ function(e) {
	return e.Connected = "Connected", e.PendingValidation = "PendingValidation", e;
}({}), T = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), E = /* @__PURE__ */ function(e) {
	return e.RPData = "RPData", e.RealEstateDotCom = "RealEstateDotCom", e.DomainDotCom = "DomainDotCom", e.DocuSign = "DocuSign", e.Rex = "Rex", e.CampaignFlow = "CampaignFlow", e;
}({}), D = /* @__PURE__ */ function(e) {
	return e.PurchaseTitleDocuments = "PurchaseTitleDocuments", e.RequestMarketingFunds = "RequestMarketingFunds", e.AutomateLiveListings = "AutomateLiveListings", e.SubmitListingToRex = "SubmitListingToRex", e.SubmitContractToRex = "SubmitContractToRex", e.HideLeaderBoardForLastFinancialYear = "HideLeaderBoardForLastFinancialYear", e.AutomateEmailListings = "AutomateEmailListings", e.AutomateEmailContracts = "AutomateEmailContracts", e.AssignCampaignFlowAdmin = "AssignCampaignFlowAdmin", e.EnableLaunchPad = "EnableLaunchPad", e.IdentityVerification = "IdentityVerification", e.EnableNswContractExchange = "EnableNswContractExchange", e.CheckForExistingCrmListing = "CheckForExistingCrmListing", e.SubmitListingToCrm = "SubmitListingToCrm", e.AgentProfileSettings = "AgentProfileSettings", e.Proposals = "Proposals", e.E2EPlatformFeature = "E2EPlatformFeature", e.E2EQldFeature = "E2EQldFeature", e.E2EPlatformFeatureRetryOne = "E2EPlatformFeatureRetryOne", e.E2EQldFeatureRetryOne = "E2EQldFeatureRetryOne", e.E2EPlatformFeatureRetryTwo = "E2EPlatformFeatureRetryTwo", e.E2EQldFeatureRetryTwo = "E2EQldFeatureRetryTwo", e;
}({}), O = /* @__PURE__ */ function(e) {
	return e.Global = "Global", e.State = "State", e.Agency = "Agency", e.AgencyState = "AgencyState", e;
}({}), k = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), A = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e;
}({}), j = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), M = /* @__PURE__ */ function(e) {
	return e.Silver = "Silver", e.Gold = "Gold", e.Platinum = "Platinum", e.XPartner = "XPartner", e.Bronze = "Bronze", e;
}({}), N = /* @__PURE__ */ function(e) {
	return e.Silver = "Silver", e.Gold = "Gold", e.Platinum = "Platinum", e.XPartner = "XPartner", e.Bronze = "Bronze", e;
}({}), P = /* @__PURE__ */ function(e) {
	return e.AgentOrTeam = "AgentOrTeam", e.Agency = "Agency", e;
}({}), F = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), I = /* @__PURE__ */ function(e) {
	return e.UrbanX = "UrbanX", e.Autopilot = "Autopilot", e;
}({}), L = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e;
}({}), R = /* @__PURE__ */ function(e) {
	return e.RPData = "RPData", e.RealEstateDotCom = "RealEstateDotCom", e.DomainDotCom = "DomainDotCom", e.DocuSign = "DocuSign", e.Rex = "Rex", e.CampaignFlow = "CampaignFlow", e;
}({}), z = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isAgenciesApiException = !0;
	static isAgenciesApiException(e) {
		return e.isAgenciesApiException === !0;
	}
};
function B(e, t, n, r, i) {
	throw i ?? new z(e, t, n, r, null);
}
//#endregion
//#region src/useClientContext.tsx
var V = "agencies";
function H(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var U = (e, t, n) => {
	let r = new p(e);
	return r.setAuthConfig(t, n), H(r);
}, W = ({ baseApiUri: e, localUris: t }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	return t?.[V] || `${e}/${V}`;
}, G = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = W(i), u = c, d = U(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		p(U(l, a, i));
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, K = a({}), q = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = G(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(K.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, J = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.assignStaffMemberToAgencies(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		assignStaffMemberToAgencies: u,
		assignStaffMemberToAgenciesPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Y = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.createAgency(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		createAgency: u,
		createAgencyPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, X = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.createAgent(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		createAgent: u,
		createAgentPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Z = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.deleteAgencySupplier(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		deleteAgencySupplier: u,
		deleteAgencySupplierPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Q = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.getAgenciesAssignedToStaffMember(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		getAgenciesAssignedToStaffMember: u,
		getAgenciesAssignedToStaffMemberPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ne = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(K), s;
	n[0] === e ? s = n[1] : (s = ["getAgencyDetails", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getAgencyDetails(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, re = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getAgencyDetails", e] });
	}, e[0] = t, e[1] = n), n;
}, ie = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(K), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getAgencyInformationForUser"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getAgencyInformationForUser(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, ae = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getAgencyInformationForUser"] });
	}, e[0] = t, e[1] = n), n;
}, oe = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(K), s;
	n[0] === e ? s = n[1] : (s = ["getAgencyMembers", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getAgencyMembers(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, se = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getAgencyMembers", e] });
	}, e[0] = t, e[1] = n), n;
}, ce = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(K), s;
	n[0] === e ? s = n[1] : (s = ["getAgencySuppliers", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getAgencySuppliers(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, le = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getAgencySuppliers", e] });
	}, e[0] = t, e[1] = n), n;
}, ue = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(K), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getAgentProfile"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getAgentProfile(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, de = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getAgentProfile"] });
	}, e[0] = t, e[1] = n), n;
}, fe = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(K), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getAgentsInAgency"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getAgentsInAgency(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, pe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getAgentsInAgency"] });
	}, e[0] = t, e[1] = n), n;
}, me = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(K), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getAllAgencies"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getAllAgencies(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, he = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getAllAgencies"] });
	}, e[0] = t, e[1] = n), n;
}, ge = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(K), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getAllUsersInformation"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getAllUsersInformation(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, _e = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getAllUsersInformation"] });
	}, e[0] = t, e[1] = n), n;
}, ve = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(K), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getAutopilotEntityDetails"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getAutopilotEntityDetails(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, ye = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getAutopilotEntityDetails"] });
	}, e[0] = t, e[1] = n), n;
}, be = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(K), s;
	n[0] === e ? s = n[1] : (s = ["getBranding", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getBranding(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, xe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getBranding", e] });
	}, e[0] = t, e[1] = n), n;
}, Se = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(K), s;
	n[0] === e ? s = n[1] : (s = ["getCommissionSettings", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCommissionSettings(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Ce = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCommissionSettings", e] });
	}, e[0] = t, e[1] = n), n;
}, we = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(K), s;
	n[0] === e ? s = n[1] : (s = ["getContractSettings", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getContractSettings(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Te = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getContractSettings", e] });
	}, e[0] = t, e[1] = n), n;
}, Ee = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(K), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getEntityGoals"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getEntityGoals(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, De = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getEntityGoals"] });
	}, e[0] = t, e[1] = n), n;
}, Oe = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(K), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getExecutiveKeyBudget"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getExecutiveKeyBudget(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, ke = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getExecutiveKeyBudget"] });
	}, e[0] = t, e[1] = n), n;
}, Ae = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(K), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getFeatureToggles"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getFeatureToggles(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, je = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getFeatureToggles"] });
	}, e[0] = t, e[1] = n), n;
}, Me = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(K), s;
	n[0] === e ? s = n[1] : (s = ["getLabGroupAgencyCode", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getLabGroupAgencyCode(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Ne = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getLabGroupAgencyCode", e] });
	}, e[0] = t, e[1] = n), n;
}, Pe = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(K), s;
	n[0] === e ? s = n[1] : (s = ["getListingAgreementSettings", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getListingAgreementSettings(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Fe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getListingAgreementSettings", e] });
	}, e[0] = t, e[1] = n), n;
}, Ie = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(K), s;
	n[0] === e ? s = n[1] : (s = ["getPublicHolidays", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getPublicHolidays(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Le = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getPublicHolidays", e] });
	}, e[0] = t, e[1] = n), n;
}, Re = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(K), c;
	i[0] !== t || i[1] !== e ? (c = [
		"getStaffMembersAssignedToAgencies",
		e,
		t
	], i[0] = t, i[1] = e, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== t || i[4] !== s || i[5] !== e ? (d = (n) => {
		let { signal: r } = n;
		return s.getStaffMembersAssignedToAgencies(e, t, r);
	}, i[3] = t, i[4] = s, i[5] = e, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, ze = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getStaffMembersAssignedToAgencies",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, Be = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(K), s;
	n[0] === e ? s = n[1] : (s = ["getTeamsForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getTeamsForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Ve = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getTeamsForAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, He = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(K), s;
	n[0] === e ? s = n[1] : (s = ["getUploadedFileLink", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getUploadedFileLink(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Ue = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getUploadedFileLink", e] });
	}, e[0] = t, e[1] = n), n;
}, We = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(K), s;
	n[0] === e ? s = n[1] : (s = ["getUrbanXTeamForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getUrbanXTeamForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Ge = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getUrbanXTeamForAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, Ke = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.removeFile(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		removeFile: u,
		removeFilePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, qe = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.removePublicDocument(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		removePublicDocument: u,
		removePublicDocumentPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Je = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.sendInvitationEmail(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		sendInvitationEmail: u,
		sendInvitationEmailPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ye = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.setAgentDetails(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		setAgentDetails: u,
		setAgentDetailsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Xe = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.setEntityGoals(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		setEntityGoals: u,
		setEntityGoalsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ze = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.setExecutiveKeyBudget(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		setExecutiveKeyBudget: u,
		setExecutiveKeyBudgetPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Qe = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.setTeamsForAgency(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		setTeamsForAgency: u,
		setTeamsForAgencyPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, $e = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.setUrbanXTeamForAgency(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		setUrbanXTeamForAgency: u,
		setUrbanXTeamForAgencyPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, et = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.softDeleteAgent(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		softDeleteAgent: u,
		softDeleteAgentPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, tt = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(K), s;
	n[0] === e ? s = n[1] : (s = ["staffGetAgentsInAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetAgentsInAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, nt = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetAgentsInAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, rt = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(K), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["staffGetAllAgents"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.staffGetAllAgents(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, it = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["staffGetAllAgents"] });
	}, e[0] = t, e[1] = n), n;
}, at = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(K), s;
	n[0] === e ? s = n[1] : (s = ["staffGetAnnualBusinessTargets", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetAnnualBusinessTargets(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ot = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetAnnualBusinessTargets", e] });
	}, e[0] = t, e[1] = n), n;
}, st = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(K), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["staffGetFeatureToggleManagement"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.staffGetFeatureToggleManagement(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, ct = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["staffGetFeatureToggleManagement"] });
	}, e[0] = t, e[1] = n), n;
}, lt = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(K), s;
	n[0] === e ? s = n[1] : (s = ["staffGetFeatureToggles", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetFeatureToggles(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ut = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetFeatureToggles", e] });
	}, e[0] = t, e[1] = n), n;
}, dt = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(K), s;
	n[0] === e ? s = n[1] : (s = ["staffGetPartnershipDetailsForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetPartnershipDetailsForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ft = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetPartnershipDetailsForAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, $ = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffSetAnnualBusinessTargets(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffSetAnnualBusinessTargets: u,
		staffSetAnnualBusinessTargetsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, pt = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffSetPartnershipDetailsForAgency(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffSetPartnershipDetailsForAgency: u,
		staffSetPartnershipDetailsForAgencyPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, mt = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffUpdateFeatureSetting(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateFeatureSetting: u,
		staffUpdateFeatureSettingPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ht = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.updateAgency(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateAgency: u,
		updateAgencyPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, gt = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.updateAgencySuppliers(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateAgencySuppliers: u,
		updateAgencySuppliersPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, _t = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.updateAgentProfile(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateAgentProfile: u,
		updateAgentProfilePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, vt = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.updateAutopilotEntityDetails(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateAutopilotEntityDetails: u,
		updateAutopilotEntityDetailsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, yt = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { agencyId: t, body: n } = e;
		return a.updateBranding(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateBranding: u,
		updateBrandingPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, bt = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { agencyId: t, body: n } = e;
		return a.updateCommissionSettings(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateCommissionSettings: u,
		updateCommissionSettingsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, xt = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { agencyId: t, body: n } = e;
		return a.updateContractSettings(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateContractSettings: u,
		updateContractSettingsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, St = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.updateLabGroupAgencyCode(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateLabGroupAgencyCode: u,
		updateLabGroupAgencyCodePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ct = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { agencyId: t, body: n } = e;
		return a.updateListingAgreementSettings(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateListingAgreementSettings: u,
		updateListingAgreementSettingsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, wt = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.uploadAgentProfilePhoto(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		uploadAgentProfilePhoto: u,
		uploadAgentProfilePhotoPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Tt = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.uploadDocument(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		uploadDocument: u,
		uploadDocumentPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Et = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(K), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.uploadPublicDocument(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		uploadPublicDocument: u,
		uploadPublicDocumentPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
};
//#endregion
export { K as AgenciesApiContext, z as AgenciesApiException, q as AgenciesApiProvider, p as AgenciesClient, V as AgenciesRoute, m as AgencyAccountType, h as AgencyAgentModelLicenceType, g as AgencyDetailsModelAccountType, _ as AgencyInfoAccountType, v as AgentDetailsLicenceType, y as Agreements, b as ApplicableStates, x as CommissionSettingsCommissionAdjustmentSalePriceReduced, S as ContractSettingsUnconditionalDisplayAs, C as ContractSettingsUnderOfferDisplayAs, ee as CrmAgentboxIntegrationSettingsConnectionStatus, te as CrmIntegrationSettingsActiveProvider, w as CrmRexIntegrationSettingsConnectionStatus, T as CustomEmailParagraphState, E as ExternalIntegrations, D as Feature, O as FeatureConfigurationScopeLevel, k as FeatureConfigurationScopeState, A as FileUploadRequestDocumentType, j as LicenceDetailsState, M as PartnershipDetailsPartnershipLevel, N as PartnershipTierLevel, P as SetEntityGoalsRequestEntityType, F as States, I as UpdateAgencyDetailsAccountType, L as UploadedDocumentDocumentType, R as UserIntegrationAccessIntegration, G as useAgenciesClientContext, J as useAssignStaffMemberToAgencies, Y as useCreateAgency, X as useCreateAgent, Z as useDeleteAgencySupplier, Q as useGetAgenciesAssignedToStaffMember, ne as useGetAgencyDetails, ie as useGetAgencyInformationForUser, oe as useGetAgencyMembers, ce as useGetAgencySuppliers, ue as useGetAgentProfile, fe as useGetAgentsInAgency, me as useGetAllAgencies, ge as useGetAllUsersInformation, ve as useGetAutopilotEntityDetails, be as useGetBranding, Se as useGetCommissionSettings, we as useGetContractSettings, Ee as useGetEntityGoals, Oe as useGetExecutiveKeyBudget, Ae as useGetFeatureToggles, Me as useGetLabGroupAgencyCode, Pe as useGetListingAgreementSettings, Ie as useGetPublicHolidays, Re as useGetStaffMembersAssignedToAgencies, Be as useGetTeamsForAgency, He as useGetUploadedFileLink, We as useGetUrbanXTeamForAgency, re as useInvalidateUseGetAgencyDetails, ae as useInvalidateUseGetAgencyInformationForUser, se as useInvalidateUseGetAgencyMembers, le as useInvalidateUseGetAgencySuppliers, de as useInvalidateUseGetAgentProfile, pe as useInvalidateUseGetAgentsInAgency, he as useInvalidateUseGetAllAgencies, _e as useInvalidateUseGetAllUsersInformation, ye as useInvalidateUseGetAutopilotEntityDetails, xe as useInvalidateUseGetBranding, Ce as useInvalidateUseGetCommissionSettings, Te as useInvalidateUseGetContractSettings, De as useInvalidateUseGetEntityGoals, ke as useInvalidateUseGetExecutiveKeyBudget, je as useInvalidateUseGetFeatureToggles, Ne as useInvalidateUseGetLabGroupAgencyCode, Fe as useInvalidateUseGetListingAgreementSettings, Le as useInvalidateUseGetPublicHolidays, ze as useInvalidateUseGetStaffMembersAssignedToAgencies, Ve as useInvalidateUseGetTeamsForAgency, Ue as useInvalidateUseGetUploadedFileLink, Ge as useInvalidateUseGetUrbanXTeamForAgency, nt as useInvalidateUseStaffGetAgentsInAgency, it as useInvalidateUseStaffGetAllAgents, ot as useInvalidateUseStaffGetAnnualBusinessTargets, ct as useInvalidateUseStaffGetFeatureToggleManagement, ut as useInvalidateUseStaffGetFeatureToggles, ft as useInvalidateUseStaffGetPartnershipDetailsForAgency, Ke as useRemoveFile, qe as useRemovePublicDocument, Je as useSendInvitationEmail, Ye as useSetAgentDetails, Xe as useSetEntityGoals, Ze as useSetExecutiveKeyBudget, Qe as useSetTeamsForAgency, $e as useSetUrbanXTeamForAgency, et as useSoftDeleteAgent, tt as useStaffGetAgentsInAgency, rt as useStaffGetAllAgents, at as useStaffGetAnnualBusinessTargets, st as useStaffGetFeatureToggleManagement, lt as useStaffGetFeatureToggles, dt as useStaffGetPartnershipDetailsForAgency, $ as useStaffSetAnnualBusinessTargets, pt as useStaffSetPartnershipDetailsForAgency, mt as useStaffUpdateFeatureSetting, ht as useUpdateAgency, gt as useUpdateAgencySuppliers, _t as useUpdateAgentProfile, vt as useUpdateAutopilotEntityDetails, yt as useUpdateBranding, bt as useUpdateCommissionSettings, xt as useUpdateContractSettings, St as useUpdateLabGroupAgencyCode, Ct as useUpdateListingAgreementSettings, wt as useUploadAgentProfilePhoto, Tt as useUploadDocument, Et as useUploadPublicDocument };
